import { isMobile } from '@/utils/common.js'
import vue from '@/main.js'

const state = {
  // 是否为手机
  isMobile: true,
  // 语言
  language: 'zh-CN',
  // layout配置
  layoutOptions: null
}

const mutations = {
  ISMOBILE (state, isMobile) {
    state.isMobile = isMobile
  },
  SETLANGUAGE(state, language) {
    vue.$i18n.locale = language
    state.language = language
  },
  SETLAYOUTOPTIONS (state, layoutOptions) {
    state.layoutOptions = layoutOptions
  }
}

const actions = {
  isMobile({ commit }) {
    const i = isMobile()
    commit('ISMOBILE', i)
  },
  setLanguage({ commit }, language) {
    commit('SETLANGUAGE', language)
  },
  setLayoutOptions({ commit }, layoutOptions) {
    commit('SETLAYOUTOPTIONS', layoutOptions)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/pageInfo.js